<script lang="ts">const WS_URL = "wss://ws-events-v3.intear.tech/events/trade_swap";
let socket = null;
let messages = [];
let isConnected = false;
// ===================
function connect() {
    // Avoid double-connect
    if (socket && isConnected)
        return;
    socket = new WebSocket(WS_URL);
    socket.onopen = () => {
        socket?.send(JSON.stringify({ And: [] }));
        console.log("WebSocket connected");
        isConnected = true;
    };
    socket.onmessage = (event) => {
        // console.log("=====================");
        // console.log(event.data);
        // console.log("=====================");
        try {
            // event.data is a string like: "[{...}]"
            const parsed = JSON.parse(String(event.data));
            console.log("=====================");
            console.log(event.data);
            console.log(parsed);
            console.log("=====================");
            // Handle both array and single object just in case
            if (Array.isArray(parsed)) {
                messages = [...parsed, ...messages]; // Add new messages to the beginning
            }
            else {
                messages = [parsed, ...messages]; // Add new message to the beginning
            }
        }
        catch (err) {
            console.error("Failed to parse message", err);
        }
    };
    socket.onerror = (event) => {
        console.error("WebSocket error:", event);
    };
    socket.onclose = () => {
        console.log("WebSocket disconnected");
        isConnected = false;
        socket = null;
    };
}
// ===================
function clearMessages() {
    messages = [];
}
// ===================
function disconnect() {
    if (socket) {
        socket.close();
        // onclose handler will set flags
    }
}
// ===================
// Optional: clean up when component is destroyed
import { onDestroy } from "svelte";
onDestroy(() => {
    if (socket && isConnected) {
        socket.close();
    }
});
</script>

<!-- =========================================== -->
<!-- =========================================== -->

<!-- STREAM PAGE -->
<!-- STREAM_PAGE -->
<section>
  <h1>STREAM TRADES</h1>
  
  <div>
    <button on:click={connect} disabled={isConnected}>
      {isConnected ? "CONNECTED" : "START STREAM"}
    </button>
    <br />
    <button on:click={disconnect} disabled={!isConnected}>STOP STREAM</button>
    <br />
    <button on:click={clearMessages} disabled={messages.length === 0}>
      CLEAR MESSAGES
    </button>
  </div>

  <div class="messages">
    {#each messages as msg}
      <div class="message">
        <p>BALANCE CHANGES:</p>
        <ul>
          {#each Object.entries(msg.balance_changes) as [token, amount]}
            <li>{token}: {amount}</li>
          {/each}
        </ul>
        <p>TRADER: {msg.trader}</p>
      </div>
    {/each}
  </div>
  
  <br />
</section>

<!-- =========================================== -->
<!-- =========================================== -->

<style>
  .messages {
    text-align: left;
  }
  .message {
    background-color: white;
    color: #474747;
    margin: 5px;
    width: 500px;
    max-width: 90vw;
    box-sizing: border-box;
    padding: 5px;
    line-break: anywhere;
  }
</style>
